import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useContext, useRef, useState } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import QuickSearch from './quick-search';
import SearchPanel from './search-panel';
import { getCompProps } from '../_utils';
import { Input, Icon } from '../index';
import { SearchSizeTypes, BorderTypes, SearchTypes } from './interface';
import devWarning from '../_utils/devwarning';

var InternalSearch = function InternalSearch(props, ref) {
  var _context, _classNames;

  var thisSearchRef = useRef();
  var searchRef = ref || thisSearchRef;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      getLangMsg = _useContext.locale.getLangMsg;

  var searchProps = getCompProps('Search', userDefaultProps, props);

  var customPrefixcls = searchProps.prefixCls,
      className = searchProps.className,
      style = searchProps.style,
      size = searchProps.size,
      disabled = searchProps.disabled,
      onPressEnter = searchProps.onPressEnter,
      prefix = searchProps.prefix,
      suffix = searchProps.suffix,
      borderType = searchProps.borderType,
      children = searchProps.children,
      type = searchProps.type,
      placeholder = searchProps.placeholder,
      onSearch = searchProps.onSearch,
      restProps = __rest(searchProps, ["prefixCls", "className", "style", "size", "disabled", "onPressEnter", "prefix", "suffix", "borderType", "children", "type", "placeholder", "onSearch"]);

  devWarning(SearchSizeTypes.indexOf(size) === -1, 'search', "cannot found search size '".concat(size, "'"));
  devWarning(BorderTypes.indexOf(borderType) === -1, 'search', "cannot found search borderType '".concat(borderType, "'"));
  devWarning(SearchTypes.indexOf(type) === -1, 'search', "cannot found search Search type '".concat(type, "'"));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var searchPrefixCls = getPrefixCls(prefixCls, 'search', customPrefixcls);
  var searchCls = classNames(searchPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(searchPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(searchPrefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(searchPrefixCls, "-focused"), focused && !disabled), _defineProperty(_classNames, "".concat(searchPrefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames, "".concat(searchPrefixCls, "-border"), borderType === 'border'), _classNames));
  var handleSearchChange = useCallback(function (event) {
    onSearch && (onSearch === null || onSearch === void 0 ? void 0 : onSearch(event));
  }, [onSearch]);
  var handlePressEnter = useCallback(function (_, event) {
    onPressEnter && (onPressEnter === null || onPressEnter === void 0 ? void 0 : onPressEnter(searchRef.current.value, event));
  }, [onPressEnter, searchRef]);
  var handleFocus = useCallback(function () {
    setFocused(true);
  }, []);
  var handleBlur = useCallback(function () {
    setFocused(false);
  }, []);
  var renderPrefix = useCallback(function () {
    if (!prefix) {
      return null;
    }

    return prefix && typeof prefix === 'boolean' ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(searchPrefixCls, "-prefix")
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })) : prefix;
  }, [prefix, searchPrefixCls]);
  var renderSuffix = useCallback(function () {
    if (!suffix) {
      return null;
    }

    return !prefix && (typeof suffix === 'boolean' && suffix ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(searchPrefixCls, "-suffix")
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "kd-search-prefix",
      type: "search"
    })) : suffix);
  }, [suffix, prefix, searchPrefixCls]);

  if (type === 'quick-search') {
    return /*#__PURE__*/React.createElement(QuickSearch, _extends({}, restProps, {
      ref: ref,
      borderType: borderType,
      disabled: disabled,
      onSearch: onSearch,
      className: className,
      style: style
    }), children);
  }

  if (type === 'panel') {
    // prefixCls后面需要跟传下去的props合并
    return /*#__PURE__*/React.createElement(SearchPanel, _extends({}, searchProps, {
      prefixCls: searchPrefixCls
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: searchCls,
    style: style
  }, /*#__PURE__*/React.createElement(Input, {
    ref: searchRef,
    size: size,
    disabled: disabled,
    placeholder: placeholder || getLangMsg('Search', 'placeholder'),
    borderType: "none",
    prefix: renderPrefix(),
    suffix: renderSuffix(),
    onChange: handleSearchChange,
    onPressEnter: handlePressEnter,
    onFocus: handleFocus,
    onBlur: handleBlur
  }));
};

var Search = /*#__PURE__*/React.forwardRef(InternalSearch);
Search.displayName = 'Search';
export default Search;